<template>
  <article class="page page-orders page-order-confirmation">
    <AppSpinner v-if="cartStore.isLoading" />

    <template v-else>
      <header class="flex justify-between items-center w-full">
        <h1>Order Confirmation</h1>

        <AppLink
          :to="{ name: 'app_cart' }"
          class="text-secondary flex items-center gap-2"
        >
          <FontAwesomeIcon
            class="text-gray"
            :icon="faCartShopping"
          />
          Back to cart
        </AppLink>
      </header>

      <section class="card-container">
        <!-- delivery method-->
        <section class="delivery">
          <div
            class="card-checkout"
            :class="!isOrdersAllDigital ? 'mb-4' : ''"
          >
            <h2>Delivery Method</h2>
            <h3>Email {{ !isOrdersAllDigital ? 'and Courier' : '' }}</h3>
            <p>{{ authStore.user?.email }}</p>
          </div>

          <!-- address form-->
          <EditAddressForm
            v-if="!isOrdersAllDigital"
            v-model:is-details-complete="isDetailsComplete"
            v-model:show-editor="showEditor"
            class="mb-4"
          />

          <!--promo code-->
          <section
            v-if="false"
            class="promo-code mb-4 bg-white shadow-md border border-gray-light"
          >
            <PromoCodeForm @apply-clicked="applyPromoCode" />
          </section>
        </section>

        <!-- Order Summary-->
        <section class="card-checkout summary h-fit pb-4 md:pb-0 flex flex-col">
          <OrderSummary>
            <div class="h-full flex flex-col justify-between flex-1">
              <AppButton
                :disabled="!isOrdersAllDigital && (!isDetailsComplete || showEditor)"
                class="btn btn-solid w-full text-white uppercase py-3 text-xl my-4"
                :class="!isOrdersAllDigital && (!isDetailsComplete || showEditor) ? 'bg-[#1C86444A]' : 'bg-[#1C8644] hover:bg-green-600'"
                :processing="isSubmitting"
                @click="checkoutCart"
              >
                {{ isSubmitting ? 'Continuing' : 'Continue' }}
              </AppButton>

              <p class="flex items-center justify-center gap-2 text-black flex-1">
                <FontAwesomeIcon :icon="faLockKeyhole" />
                Secure Checkout
              </p>
            </div>
          </OrderSummary>
        </section>
      </section>

      <AppCopyRightInfo />
    </template>
  </article>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

import { AppButton, AppCopyRightInfo, AppLink, AppSpinner } from '@/components/app';
import { EditAddressForm, PromoCodeForm } from '@/components/forms';
import { OrderSummary } from '@/components/orders';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCartShopping, faLockKeyhole } from '@fortawesome/pro-solid-svg-icons';

import { useFormSubmit, useHttp } from '@/composables';
import config from '@/config';
import { useAuthStore, useCartStore } from '@/store';

const { isSubmitting } = useFormSubmit();

const router = useRouter();
const authStore = useAuthStore();
const cartStore = useCartStore();

// When there are no items in the cart, the user is taken to the Order list view
onMounted(async () => {
  if (!cartStore?.cart || cartStore?.cart?.length === 0) {
    await router.push({ name: 'app_orders' });
  }
});

const isDetailsComplete = computed(() => {
  if (!cartStore?.cart || cartStore?.cart.length === 0) {
    return true;
  }

  return Object.entries(cartStore.cart.deliveryDetails).filter(([key]) => key !== 'building').every(([key, value]) => value !== null);
});

const isOrdersAllDigital = computed(() => {
  return cartStore?.cart?.deliveryFee === 0;
});

const showEditor = ref(false);

const checkoutCart = async () => {
  isSubmitting.value = true;

  const response = await useHttp().post('/cart/checkout');

  const cart = cartStore.cart;

  if (response.statusCode === HttpStatusCode.Ok) {
    const paymentResponse = await useHttp().post('/payments', { 'order': cart.id });

    if (paymentResponse.statusCode === HttpStatusCode.Ok) {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = config.payfastUrl;

      Object.entries(paymentResponse.data).forEach(([key, value]) => {
        const input = document.createElement('input');

        input.type = 'hidden';
        input.name = key;
        input.value = value;

        form.appendChild(input);
      });

      document.body.appendChild(form);

      form.submit();

      document.body.removeChild(form);
    } else {
      isSubmitting.value = false;
    }
  } else {
    isSubmitting.value = false;
  }
};

// not sure if this should be in a mounted function its necessary cuz if u have errors on the form and press back and go to checkout again it will retain all errors
cartStore.errors = null;

const applyPromoCode = () => {
  console.log('test');
};
</script>
